import { useVTApiClient } from './client'
import { useApiKey } from './useApiKey'
import { useQuery, useQueries } from '@maui/react-query'
import { normalizeCollection } from '@/adapters'

export const useCollectionItem = ({ id }, options = {}) => {
  const api = useVTApiClient('collections')
  const { data: apiKey } = useApiKey()
  const ready = !!(id && apiKey)

  return useQuery({
    queryFn: () => api.fetch({ id, apiKey }),
    queryKey: ['collections', 'item', id, apiKey],
    select: ({ data }) => normalizeCollection(data?.attributes),
    ...options,
    enabled: options.enabled !== false && ready,
  })
}

export const useCollectionItemQueries = ({ ids }, options = {}) => {
  const api = useVTApiClient('collections')
  const { data: apiKey } = useApiKey()
  const ready = !!(ids && apiKey)
  return useQueries({
    queries: ids.map((id, i) => {
      return {
        queryKey: ['collections', 'item', id, apiKey],
        queryFn: () => api.fetch({ id, apiKey }),
        select: ({ data }) => normalizeCollection(data?.attributes),
        ...options,
        enabled: options.enabled !== false && id && ready,
      }
    }),
  })
}

export const useCollectionGraphIDQuery = ({ id }, options = {}) => {
  const api = useVTApiClient('collections')
  const { data: apiKey } = useApiKey()
  const ready = !!(id && apiKey)
  return useQuery({
    queryFn: () => api.fetchGraphId({ id, apiKey }),
    queryKey: ['collections', 'graph', id, apiKey],
    select: ({ data }) => data?.[0]?.id,
    ...options,
    enabled: options.enabled !== false && ready,
  })
}

export const useCollectionDownloadApi = ({ id, fileFormat }, options = {}) => {
  const api = useVTApiClient('collections')
  const { data: vtApiKey } = useApiKey()
  const ready = !!(id && vtApiKey && fileFormat)
  return useQuery({
    queryFn: () => api.downloadCollection({ id, vtApiKey, fileFormat }),
    queryKey: ['collections', 'download', id, vtApiKey, fileFormat],
    ...options,
    enabled: options.enabled !== false && ready,
  })
}
